<template>
  <div>
    <img
      v-if="icon"
      :src="icon"
      :title="label.titleize()"
      class="h-7 w-auto mx-auto"
    />
    <template v-else>{{ label }}</template>
  </div>
</template>

<script>
import { getInYardSvgUrl } from "@/default/utils/svgs";

export default {
  name: "order-status-yard-status",
  props: {
    item: Object,
    options: Object,
  },
  computed: {
    status() {
      return this.item.operation && this.item.operation.status;
    },
    icon() {
      return this.status ? getInYardSvgUrl(this.status) : undefined;
    },
    label() {
      return this.status ? this.status.titleize() : "";
    },
  },
};
</script>
